module.exports = __webpack_public_path__ + "img/king-solomons-mines.73ce242c.jpg";